import { cn } from '@/shadcn-ui/utils';
import { SVGProps } from 'react';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export interface CancelCircleProps extends SVGProps<SVGSVGElement>, SvgIconCommonProps {
  dark?: boolean;
  circleClassName?: string;
}

export default function CancelWithCircle({
  dark = false,
  className,
  circleClassName,
  fillPrimary,
  ...props
}: CancelCircleProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      className={cn(
        'group transition-transform active:scale-95',
        {
          'text-flexcar-neutral20': !dark,
          'text-flexcar-neutral90': dark,
        },
        className
      )}
      {...props}
    >
      <circle
        cx="16"
        cy="16"
        r="16"
        className={cn(
          'transition-colors',
          {
            'fill-flexcar-neutral90 group-hover:fill-flexcar-neutral80': !dark,
            'fill-flexcar-neutral100/30 group-hover:fill-flexcar-neutral10': dark,
          },
          circleClassName
        )}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95891 9.95967C10.3494 9.56915 10.9826 9.56915 11.3731 9.95967L22.0398 20.6263C22.4303 21.0169 22.4303 21.65 22.0398 22.0405C21.6493 22.4311 21.0161 22.4311 20.6256 22.0405L9.95891 11.3739C9.56838 10.9834 9.56838 10.3502 9.95891 9.95967Z"
        className={cn({ 'fill-current': fillPrimary === undefined })}
        fill={fillPrimary}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.0409 9.95964C22.4315 10.3502 22.4315 10.9833 22.0409 11.3739L11.3743 22.0405C10.9838 22.431 10.3506 22.431 9.96006 22.0405C9.56954 21.65 9.56954 21.0168 9.96006 20.6263L20.6267 9.95964C21.0173 9.56912 21.6504 9.56912 22.0409 9.95964Z"
        className={cn({ 'fill-current': fillPrimary === undefined })}
        fill={fillPrimary}
      />
    </svg>
  );
}
